import { ResourceKey } from "i18next";

export const RelatedTenders: ResourceKey = {
	relatedTendersTitle: "Marchés connexes",
	callToAction: "Inscrivez-vous en quelques secondes pour voir plus de marchés pertinents",
}